import { getAuthToken } from '@mopla/business-logic';
import { Logger } from '@mopla/logger';
import { client } from '@mopla/ticketshop-api';

export const configureTicketshopClient = (baseUrl: string) => {
	const logger = Logger.getInstance('Auth');

	// Configure the singleton client used by the generated SDK + query helpers.
	// Must use setConfig (not createClient) so the SDK picks up the baseUrl —
	// createClient returns a separate instance the SDK never references.
	client.setConfig({ baseUrl });

	// The OpenAPI spec declares no per-operation security, so the client's
	// `auth` callback never fires. Attach the bearer token via a request
	// interceptor instead, so every request carries Authorization.
	client.interceptors.request.use(async (request) => {
		try {
			const token = await getAuthToken();

			if (token) {
				request.headers.set('Authorization', `Bearer ${token}`);
			}
		} catch (e) {
			logger.error('Error getting auth token: ', e);
		}

		return request;
	});
};
